import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { logUsage } from 'owa-analytics';
import getDensityOptionState from '../store/store';
import { getSecondarySettingDefaultsForMode } from '../utils/getSecondarySettingDefaultsForMode';
import { saveDensityOption } from './saveDensityOption';

export default async function saveDensityOptionQuickSettings(): Promise<void> {
    const densityOptionSelected = getDensityOptionState().densityModeSelected;

    if (densityOptionSelected !== null) {
        // We have opinions about some secondary settings as well.
        const secondarySettings = getSecondarySettingDefaultsForMode(densityOptionSelected);

        logUsage('DisplayDensityQuickSettings', getGlobalSettingsAccountMailboxInfo(), [
            densityOptionSelected,
        ]);
        return saveDensityOption(densityOptionSelected, secondarySettings);
    }
}
